/* eslint-disable react-hooks/exhaustive-deps */
import { useTheme } from '@emotion/react';
import React, { useContext, useState } from 'react';
import { Avatar, Box, useMediaQuery, IconButton, Menu, MenuItem, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../../provider/authProvider';
import { getMenuItems } from './menuItems';
import { useLocation, useNavigate } from 'react-router-dom';
import { api } from '../../services/networkService';
import AuthService from '../../services/authService';
import kurdistanFlag from '../../assets/images/kurdistanFlag.png';
import usaFlag from '../../assets/images/usaFlag.png';
import iraqFlag from '../../assets/images/iraqFlag.png';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useCompany } from '../../provider/companyProvider';

function Navbar() {
    const theme = useTheme();
    const { t, i18n } = useTranslation();
    const { user } = useContext(AuthContext);
    const location = useLocation();
    const isTablet = useMediaQuery(theme.breakpoints.down('sm'));
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState(null);
    const { refetch } = useCompany();

    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const userPermissions = user?.permissions || [];
    const menuItems = getMenuItems(t, userPermissions);

    const findActiveMenuItem = () => {
        const matchPath = (menuPath, currentPath) => {
            if (menuPath.includes(':id')) {
                const basePath = menuPath.replace('/:id', '');
                return currentPath.startsWith(basePath);
            }
            return menuPath === currentPath;
        };

        for (let item of menuItems) {
            if (matchPath(item.path, location.pathname) && !item.items) {
                return item;
            }
            if (item.items) {
                for (let subItem of item.items) {
                    if (matchPath(subItem.path, location.pathname)) {
                        return subItem;
                    }
                }
            }
        }

        return null;
    };

    const activeMenuItem = findActiveMenuItem();

    const languages = [
        { code: 'ku', name: 'کوردی', flag: kurdistanFlag },
        { code: 'en', name: 'English', flag: usaFlag },
        { code: 'ar', name: 'عربي', flag: iraqFlag },
    ];

    const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

    const changeLanguage = async (lang) => {
        try {
            await AuthService.changeLanguage({ language: lang });
        } catch (error) {
            console.error("An unexpected error occurred:", error);
        }

        i18n.changeLanguage(lang);

        await refetch();
        // handleClose();
    };

    return (
        <Box sx={{
            height: 50,
            width: '100%',
            px: 2,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            backgroundColor: 'white',
            borderBottom: 1,
            borderBottomColor: theme.palette.secondary.main,
            position: 'relative',
            zIndex: 1100,
        }}>
            {/* page name */}
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                width: '20%'
            }}>
                {activeMenuItem && activeMenuItem.icon}
                <p style={{
                    color: theme.palette.text.primary, marginInline: 10,
                    fontSize: isMobile ? 16 : 18
                }}>{activeMenuItem && activeMenuItem.text}</p>
            </Box>

            <Box sx={{
                display: 'flex',
                width: '80%',
                justifyContent: 'end'
            }}>
                {/* langauges */}
                <Box sx={{ display: 'flex', alignItems: 'center', mx: 2 }}>
                    <IconButton onClick={handleOpen} sx={{
                        p: 0, ":hover": {
                            color: 'transparent',
                            backgroundColor: 'transparent'
                        }
                    }}>
                        <Avatar src={currentLanguage.flag} alt={currentLanguage.name} sx={{ width: 28, height: 20, borderRadius: 0 }} />
                        <Box width={isTablet ? 2 : 8}></Box>
                        {
                            !isTablet && <Typography variant="body1" sx={{ color: 'text.primary' }}>
                                {currentLanguage.name}
                            </Typography>
                        }
                        <KeyboardArrowDownIcon sx={{ color: 'text.primary' }} />
                    </IconButton>

                    {/* Dropdown menu */}
                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                    >
                        {languages.map((lang) => (
                            <MenuItem
                                key={lang.code}
                                onClick={() => changeLanguage(lang.code)}
                                sx={{ display: 'flex', alignItems: 'center' }}
                            >
                                <Avatar src={lang.flag} alt={lang.name} sx={{ width: 28, height: 20, borderRadius: 0 }} />
                                <Box width={8}></Box>
                                <Typography variant="body1">{lang.name}</Typography>
                            </MenuItem>
                        ))}
                    </Menu>
                </Box>
                {/* user box */}
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer'
                    }}
                    onClick={() => {
                        navigate('/profile');
                    }}
                >
                    <Avatar src={api + "/public/user/user.jpg"}></Avatar>
                    {
                        !isTablet && <Box sx={{ color: theme.palette.text.primary, marginX: 1.4 }}>
                            <p style={{ fontSize: 14, margin: 0 }}>{user.name}</p>
                            <p style={{ fontSize: 12, margin: 0 }}>{user.role.name}</p>
                        </Box>
                    }
                </Box>
            </Box>
        </Box>
    );
}

export default Navbar;
